import "./button-filled.scss";
import React, { forwardRef, useMemo, useState } from "react";
import variables from "../../styles/variables.scss";

const COLOR_MAP = {
  primary: { base: "primary", dark: "primaryDark" },
  secondary: { base: "secondary", dark: "secondaryDark" },
  accent: { base: "accent", dark: "accentDark" },
};

const ButtonFilled = forwardRef(function ButtonFilled(
  {
    text,
    color = "primary",
    hoverColor,
    reversed = false,
    disabled = false,
    large = false,
    wide = false,
    type = "button",
    className,
    children,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    onClick,
    ...rest
  },
  ref
) {
  const { resolvedColor, resolvedHover } = useMemo(() => {
    const token = COLOR_MAP[color] ? COLOR_MAP[color] : COLOR_MAP.primary;
    const base = variables[token.base] || variables.primary;
    const dark = hoverColor || variables[token.dark] || variables.primaryDark;
    return { resolvedColor: base, resolvedHover: dark };
  }, [color, hoverColor]);

  const [active, setActive] = useState(false);

  const handleMouseEnter = (e) => {
    if (!disabled) setActive(true);
    onMouseEnter?.(e);
  };
  const handleMouseLeave = (e) => {
    if (!disabled) setActive(false);
    onMouseLeave?.(e);
  };
  const handleFocus = (e) => {
    if (!disabled) setActive(true);
    onFocus?.(e);
  };
  const handleBlur = (e) => {
    if (!disabled) setActive(false);
    onBlur?.(e);
  };

  const classes = [
    "button-filled",
    reversed && "reversed",
    disabled && "disabled",
    large && "large",
    wide && "wide",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inlineStyle = disabled
    ? undefined
    : reversed
    ? {
        color: active ? variables.white : resolvedColor,
        backgroundColor: active ? "transparent" : variables.white,
      }
    : {
        backgroundColor: active ? resolvedHover : resolvedColor,
        borderBottom: `3px solid ${resolvedHover}`,
      };

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={classes}
      style={inlineStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={onClick}
      {...rest}
    >
      {children ?? text}
    </button>
  );
});

export default ButtonFilled;
